<template>
  <div
    id="app-view"
    class="app-view">
    <Header/>
    <router-view/>
    <Footer/>

  </div>
</template>

<script>
/**
 * AppView Component
 * This is the main container for the app.
 * @author Fernando Torres
 * @version 1.0.0
 * @copyright Marciano Studio S.C., 2018.
 */
import Header from '../../components/header/header'
import Footer from '../../components/footer/footer'

export default {
  name: 'AppView',
  components: {
    Header, Footer
  }
}
</script>

<style lang="scss" scoped>
  .app-view{
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/app.view.vue